<template>
  <div class="apply">
    <h2>申请证书</h2>
    <el-form class="exam-form" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="140px">
      <el-form-item label="申请证书名称：" prop="title">
        <el-input v-model="dataForm.title" placeholder="请输入申请证书" :disabled="true"></el-input>
      </el-form-item>
      <!-- <el-form-item label="身份证号：" prop="personNumber">
        <el-input v-model="dataForm.personNumber" clearable placeholder="请输入身份证号"></el-input>
      </el-form-item> -->
      <el-form-item label="申请人姓名：" prop="name">
        <el-input v-model="dataForm.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="申请人联系方式：" prop="mobile">
        <el-input v-model="dataForm.mobile" placeholder="请输入联系方式"></el-input>
      </el-form-item>
    </el-form>
    <div class="exam-form opts">
      <button class="button" :class="{' forbidden but-loading':butLoading}" @click="goBack()"><i class="el-icon-loading" v-show="butLoading"></i>取消</button>
      <button class="button-primary" :class="{' forbidden but-loading':butLoading}" @click="dataFormSubmit()"><i class="el-icon-loading" v-show="butLoading"></i>提交</button>
    </div>
  </div>
</template>
<script>
import { isMobile } from '@/utils/validate'
export default {
  data () {
    var validateMobile = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    // var validateIdCard = (rule, value, callback) => {
    //   let regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    //   if (value && !regIdCard.test(value)){
    //     callback(new Error('请输入正确的身份证号'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      butLoading: false,
      dataForm: {
        id: '',
        title: '',
        name: '',
        mobile: ''
        // personNumber: ''
      },
      dataRule: {
        title: [
          // { required: true, message: '考试名称不能为空', trigger: 'change' }
        ],
        name: [
          { required: true, message: '申请人不能为空', trigger: 'change' }
        ],
        // personNumber: [
        //   // { required: true, message: '身份证号不能为空', trigger: 'change' },
        //   { validator: validateIdCard, trigger: 'blur' }
        // ],
        mobile: [
          { required: true, message: '申请人联系方式不能为空', trigger: 'change' },
          { validator: validateMobile, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.dataForm.id = this.examId
    this.dataForm.title = this.examName
    this.dataForm.name = this.$route.query.name
    this.dataForm.mobile = this.$route.query.mobile
  },
  computed: {
    examId () {
      return this.$route.query.id
    },
    examName () {
      return this.$route.query.title
    }
  },
  watch: {
    examId (val) {
      this.dataForm.id = val
      this.dataForm.name = this.$route.query.name
      this.dataForm.mobile = this.$route.query.mobile
    },
    examName (val) {
      this.dataForm.title = val
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    dataFormSubmit () {
      if (this.butLoading) {
        return false
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.butLoading = true
          this.$http.post(`/front/train/trainEmPaperUser/applyExamCertificate`,
            {
              'id': this.dataForm.id,
              'certificateName': this.dataForm.name,
              'mobile': this.dataForm.mobile
            })
            .then(data => {
              if (data.data.code === 0) {
                this.$message.success('申请成功')
                this.butLoading = false
                this.goBack()
              } else {
                this.$message.error(data.data.msg || '申请失败')
                this.butLoading = false
              }
            })
            .catch(() => {
              this.$message.error('申请失败')
              this.butLoading = false
            })
          // this.$http.post(`${window.SITE_CONFIG['trainURL']}/exam/trainempaperuser/save`, {...this.dataForm})
          // .then(data => {
          //   if (data.data.code === 0) {
          //     this.$message.success('报名成功')
          //     this.butLoading = false
          //     this.goBack()
          //   } else {
          //     this.$message.error(data.data.msg || '报名失败')
          //     this.butLoading = false
          //   }
          // })
          // .catch(err => {
          //   this.$message.error('报名失败')
          //   this.butLoading = false
          // })
        }
      })
    }
  }
}
</script>
<style scoped>
.apply{
  margin: 40px 80px;
}
h2{
  line-height: 28px;
  font-size: 20px;
  color: #333333;
}
.exam-form{
  width: 500px;
  margin: 20px auto;
}
.opts{
  text-align: center;
}
.button{
  padding: 9px 43px;
  border: 1px solid #1D65A8;
  color: #1D65A8;
  background: #fff;
  cursor: pointer;
}
.button-primary{
  padding: 9px 43px;
  border: 1px solid #1D65A8;
  color: #fff;
  background: #1D65A8;
  cursor: pointer;
}
</style>
